"use client";

import { useToastStore } from "@/store/index";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useEffect } from "react";

interface QuantitySelectorProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onReset: () => void;
  max?: number;
  min?: number;
}

export function QuantitySelector({
  quantity,
  onIncrement,
  onDecrement,
  onReset,
  max = 99,
  min = 1,
}: QuantitySelectorProps) {
  const { showToast } = useToastStore();

  // TODO Forward add a suscription to notify users about changes in products stock.
  useEffect(() => {
    if (quantity >= max)
      showToast(`Lo sentimos, solo disponemos de ${max} unidades.`, "err");
  }, [quantity]);

  return (
    <>
      <div className="border-green-main inline-flex items-center gap-2 rounded-xl border-2 bg-transparent px-2 py-1">
        {/* Decrement Button */}
        <button
          onClick={onDecrement}
          disabled={quantity <= min}
          className="bg-green-main flex h-7 w-7 items-center justify-center rounded-full text-white transition-colors hover:bg-[#047a2e] disabled:cursor-not-allowed disabled:opacity-50"
        >
          <Minus className="h-4 w-4" />
        </button>

        {/* Quantity Display */}
        <span className="font-inter min-w-[2rem] text-center text-base font-semibold text-gray-800">
          {quantity}
        </span>

        {/* Increment Button */}
        <button
          onClick={onIncrement}
          disabled={quantity >= max}
          className="bg-green-main flex h-7 w-7 items-center justify-center rounded-full text-white transition-colors hover:bg-[#047a2e] disabled:cursor-not-allowed disabled:opacity-50"
        >
          <Plus className="h-4 w-4" />
        </button>
      </div>

      {/* Reset/Trash Button */}
      <button
        onClick={onReset}
        className="text-green-main hover:bg-green-main/10 ml-1 flex h-7 w-7 items-center justify-center rounded-full transition-colors"
      >
        <Trash2 className="h-5 w-5" />
      </button>
    </>
  );
}
